import { useMutation } from '@tanstack/react-query';
import { useSearchParams } from 'react-router-dom';
import { UpdateEventDraftCommandInput, UpdateEventDraftCommandOutput } from '@amzn/red-velvet-api';
import { useFeatures, getEnabledFeatures } from '../features';
import { getClient } from '../../utils/getClient';

const MUTATION_PREFIX = ['RedVelvetApi', 'updateEventDraft'];

export function useUpdateEventDraft() {
  const features = useFeatures();
  const [searchParams] = useSearchParams();
  const client = getClient(getEnabledFeatures(features, searchParams));

  return useMutation<UpdateEventDraftCommandOutput, Error, UpdateEventDraftCommandInput>({
    mutationKey: [...MUTATION_PREFIX],
    mutationFn: (input) => client.updateEventDraft(input),
    retry: 2, // Automatically retry up to 2 times on failure
  });
}
